import EventsCreate from './EventsCreate';

export default EventsCreate;
